import { type FormEvent, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { clientsApi } from '../api/clients.js';
import { useAppShell } from '../components/AppShell.js';

export function ClientNewPage(): JSX.Element {
  const navigate = useNavigate();
  const { setBackTo } = useAppShell();

  // Back button (BB-UX-01)
  useEffect(() => {
    setBackTo({ href: '/clients', label: 'Clientes' });
    return () => setBackTo(null);
  }, [setBackTo]);
  const [name, setName] = useState('');
  const [rnc, setRnc] = useState('');
  const [sector, setSector] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const created = await clientsApi.create({
        name: name.trim(),
        ...(rnc.trim() ? { rnc: rnc.trim() } : {}),
        ...(sector.trim() ? { sector: sector.trim() } : {}),
      });
      navigate(`/clients/${created.id}`, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error creando cliente');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="mx-auto max-w-md px-4 py-6 space-y-5">
      <Link to="/clients" className="text-sm text-brand-700 hover:underline">
        ← Volver
      </Link>
      <h1 className="text-xl font-semibold text-brand-900">Nuevo cliente</h1>
      <form
        onSubmit={(e) => {
          void handleSubmit(e);
        }}
        className="space-y-4"
      >
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-slate-700">
            Razon social <span className="text-red-600">*</span>
          </label>
          <input
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-3 text-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/30"
          />
        </div>
        <div>
          <label htmlFor="rnc" className="block text-sm font-medium text-slate-700">
            RNC
          </label>
          <input
            id="rnc"
            value={rnc}
            onChange={(e) => setRnc(e.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-3 text-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/30"
          />
        </div>
        <div>
          <label htmlFor="sector" className="block text-sm font-medium text-slate-700">
            Sector
          </label>
          <input
            id="sector"
            value={sector}
            onChange={(e) => setSector(e.target.value)}
            placeholder="Banca, Salud, Industria..."
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-3 text-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/30"
          />
        </div>
        {error && (
          <div role="alert" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={submitting || !name.trim()}
          className="w-full rounded-lg bg-brand-700 px-4 py-3 text-sm font-medium text-white hover:bg-brand-700/90 disabled:cursor-not-allowed disabled:bg-slate-300"
        >
          {submitting ? 'Creando...' : 'Crear cliente'}
        </button>
      </form>
    </main>
  );
}
